module.exports = __webpack_public_path__ + "img/9788954429955.78c80cd2.jpg";